import React from 'react'
import { Calculator, DollarSign } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export const Payroll: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Payroll Management</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">Process and manage employee payroll</p>
        </div>
        <Button><Calculator className="w-4 h-4 mr-2" />Process Payroll</Button>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <DollarSign className="w-5 h-5" />Payroll Management
          </CardTitle>
          <CardDescription>Employee salary processing and management</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <Calculator className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Payroll System</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Automated payroll processing and reporting</p>
            <Button variant="outline">View Details</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
